(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6816],{

/***/ 84929:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recursos",
      function () {
        return __webpack_require__(68912);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Paragraph/Paragraph.js





var defaultProps = {
    className: "",
    children: null
};
var propTypes = {
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Paragraph(_param) {
    var className = _param.className, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, otherProps), {
        children: children
    }));
};
Paragraph.defaultProps = defaultProps;
Paragraph.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Paragraph/index.js

/* harmony default export */ var components_Paragraph = (Paragraph);


/***/ }),

/***/ 77276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SubHeading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/DynamicPropsInjection/index.js + 3 modules
var DynamicPropsInjection = __webpack_require__(2183);
// EXTERNAL MODULE: ./src/shapes/index.js + 16 modules
var shapes = __webpack_require__(71634);
;// CONCATENATED MODULE: ./src/components/Spacing/Spacing.js







var defaultProps = {
    horizontal: null,
    vertical: null,
    top: null,
    bottom: null,
    left: null,
    right: null,
    type: "m",
    inject: false,
    className: "",
    children: null
};
var propTypes = {
    horizontal: shapes/* ShapeSpacing */.N0,
    vertical: shapes/* ShapeSpacing */.N0,
    top: shapes/* ShapeSpacing */.N0,
    bottom: shapes/* ShapeSpacing */.N0,
    left: shapes/* ShapeSpacing */.N0,
    right: shapes/* ShapeSpacing */.N0,
    type: prop_types_default().oneOf([
        "m",
        "p"
    ]),
    inject: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Spacing(_param) {
    var horizontal = _param.horizontal, vertical = _param.vertical, top = _param.top, bottom = _param.bottom, left = _param.left, right = _param.right, type = _param.type, inject = _param.inject, className = _param.className, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "horizontal",
        "vertical",
        "top",
        "bottom",
        "left",
        "right",
        "type",
        "inject",
        "className",
        "children"
    ]);
    var classes = [
        className
    ];
    if (horizontal || left === right && left !== null) {
        classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
            "".concat(type, "x-").concat(horizontal || left)
        ]);
    } else {
        if (left !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "l-").concat(left)
            ]);
        }
        if (right !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "r-").concat(right)
            ]);
        }
    }
    if (vertical || top === bottom && top !== null) {
        classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
            "".concat(type, "y-").concat(vertical || top)
        ]);
    } else {
        if (top !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "t-").concat(top)
            ]);
        }
        if (bottom !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "b-").concat(bottom)
            ]);
        }
    }
    var content;
    if (!inject) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: children
        });
    } else {
        content = children;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPropsInjection/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(classes),
        props: rest,
        children: content
    });
};
Spacing.defaultProps = defaultProps;
Spacing.propTypes = propTypes;


;// CONCATENATED MODULE: ./src/components/Spacing/index.js

/* harmony default export */ var components_Spacing = (Spacing);


// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Text/index.js + 1 modules
var Text = __webpack_require__(37346);
;// CONCATENATED MODULE: ./src/components/SubHeading/SubHeading.js






var SubHeading_defaultProps = {
    color: "text-green-500"
};
var SubHeading_propTypes = {
    heading: (prop_types_default()).string.isRequired,
    color: (prop_types_default()).string
};
function SubHeading(param) {
    var heading = param.heading, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Spacing, {
        bottom: 4,
        inject: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            padding: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: (0,clsx_m/* default */.Z)("inline-flex text-xl font-semibold leading-none tracking-tight", color),
                children: heading
            })
        })
    });
};
SubHeading.defaultProps = SubHeading_defaultProps;
SubHeading.propTypes = SubHeading_propTypes;

;// CONCATENATED MODULE: ./src/components/SubHeading/index.js

/* harmony default export */ var components_SubHeading = (SubHeading);


/***/ }),

/***/ 37346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Text; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
;// CONCATENATED MODULE: ./src/components/Text/Text.js




var defaultProps = {
    muted: false,
    xsmall: false,
    small: false,
    large: false,
    medium: false,
    semibold: false,
    className: "",
    children: ""
};
var propTypes = {
    muted: (prop_types_default()).bool,
    xsmall: (prop_types_default()).bool,
    small: (prop_types_default()).bool,
    large: (prop_types_default()).bool,
    medium: (prop_types_default()).bool,
    semibold: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Text(param) {
    var muted = param.muted, xsmall = param.xsmall, small = param.small, large = param.large, medium = param.medium, semibold = param.semibold, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(className, {
            "text-gray-500": muted,
            "text-xs": xsmall,
            "text-sm": small,
            "text-lg": large,
            "font-medium": medium,
            "font-semibold": semibold
        }),
        children: children
    });
};
Text.defaultProps = defaultProps;
Text.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Text/index.js

/* harmony default export */ var components_Text = (Text);


/***/ }),

/***/ 68912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Resources; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_SubHeading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77276);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30341);



function Resources() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-green-100 bg-gradient-to-br from-green-100 to-green-50",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-1 lg:grid-cols-12",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col py-10 lg:col-span-6 lg:py-20",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SubHeading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            heading: "Recursos"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-4xl font-extrabold lg:text-5xl",
                            children: "Te recomendamos algunos recursos para tu aprendizaje"
                        })
                    ]
                })
            })
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(84929); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);